import { render, staticRenderFns } from "./NewShoppingCartPR.vue?vue&type=template&id=c5323f32&scoped=true&"
import script from "./NewShoppingCartPR.vue?vue&type=script&lang=js&"
export * from "./NewShoppingCartPR.vue?vue&type=script&lang=js&"
import style0 from "./NewShoppingCartPR.vue?vue&type=style&index=0&id=c5323f32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5323f32",
  null
  
)

export default component.exports